<template>
  <div class="cost-mapping">
    <div class="flex justify-between items-center pb-6 shadow-border-b gap-8 mdmax:gap-2 mdmax:flex-col">
      <div class="flex-1 mdmax:flex-auto mdmax:w-full">
        <LinkButton buttonText="Tambah Cost Mapping" url="/package/cost-mapping/create" linkType="internal" :size="isMobile ? 'full' : 'regular'" />
      </div>
      <div class="flex-1 flex justify-end gap-8 mdmax:flex-auto mdmax:w-full mdmax:justify-start">
        <div class="w-3/5  mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Cari pemetaan biaya" v-model="searchTerm" @enter="doSearch" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <div class="flex gap-3 items-center" v-if="column.field === 'action'">
          <router-link :to="`/package/cost-mapping/detail/${entry.id}`" class="inline-block cursor-pointer"><EyeOpen color="neutral-700"/></router-link>
          <router-link :to="`/package/cost-mapping/detail/${entry.id}/update`" class="inline-block cursor-pointer"><Pencil color="neutral-700"/></router-link>
          <router-link :to="`/package/cost-mapping/detail/${entry.id}/duplicate`" class="inline-block cursor-pointer"><Copy color="neutral-700"/></router-link>
          <span class="inline-block cursor-pointer" @click="toggleCMDeleteConfirmation(entry.id)"><Trash color="neutral-700"/></span>
        </div>
        <span class="block break-all" v-else-if="column.field === 'id'" :title="entry.id">
          {{ entry.id }}
        </span>
        <span v-else>{{ entry[column.field] }}</span>
      </template>
    </TableComponent>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
    <Modal :modalVisible="visibleCMDeleteConfirmation" @close="toggleCMDeleteConfirmation()" width="600px" id="delete-confirmation-modal">
      <template slot="modal-content">
        <div class="flex items-center justify-start gap-6 mb-6">
          <span class="flex-shrink-0"><Alert color="neutral-700"/></span>
          <div class="flex-col flex gap-2 items-start">
            <p class="text-2xl font-bold">Hapus Cost Mapping?</p>
            <p class="text-sm text-neutral-500 text-left">
              Menghapus cost mapping akan berpengaruh terhadap layanan dan tidak bisa dibisa di kembalikan. pastikan cost mapping yang akan di buat tidak terkoneksi dengan layanan apapun
            </p>
          </div>
        </div>
        <div class="flex justify-end gap-6">
          <Button buttonText="Tidak" type="secondary" @action="toggleCMDeleteConfirmation()" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Ya" type="primary" @action="confirmCMDelete()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    Trash: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Trash'),
    Copy: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Copy'),
    Pencil: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Pencil'),
    EyeOpen: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/EyeOpen'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    Alert: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Alert'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal')
  },
  data() {
    return {
      searchTerm: '',
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true,
      columns: [
        // { label: 'ID', field: 'id' },
        { label: 'Nama Cost Mapping', field: 'name' },
        { label: 'Basecost entry', field: 'base_cost_entry_total' },
        { label: 'Koneksi Layanan', field: 'packages' },
        { label: 'Action', field: 'action' }
      ],
      visibleCMDeleteConfirmation: false,
      selectedCostMappingId: null
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('partner', ['costMapping']),
    ...mapGetters('auth', ['userData']),
    partnerId() {
      return this.userData?.user?.group_id
    },
    filteredData() {
      let temp = this.costMapping || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.perPage + this.perPage
      return lastOnPage > this.total ? this.total : lastOnPage
    }
  },
  methods: {
    ...mapActions('partner', ['getCostMapping', 'removeCostMapping']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    confirmCMDelete() {
      this.showLoading()
      this.removeCostMapping({
        partnerId: this.partnerId,
        costMappingId: this.selectedCostMappingId
      })
        .then(() => {
          let self = this
          this.hideLoading()
          this.toggleCMDeleteConfirmation()
          this.setToast({
            options: {
              type: 'success',
              duration: 1000,
              primaryText: 'Berhasil Menghapus Cost Mapping',
              secondaryText: 'Data telah kami simpan',
              callback: () => {
                self.$router.push('/package/cost-mapping')
              }
            }
          })
        })
        .catch(error => {
          this.hideLoading()
          this.toggleCMDeleteConfirmation()
          this.setToast({
            options: {
              type: 'danger',
              duration: 5000,
              primaryText: 'Gagal Menghapus Cost Mapping',
              secondaryText: error.response.data.message,
              callback: () => {
                this.$router.push('/package/cost-mapping')
              }
            }
          })
        })
    },
    toggleCMDeleteConfirmation(id = null) {
      this.visibleCMDeleteConfirmation = !this.visibleCMDeleteConfirmation
      if (!this.visibleCMDeleteConfirmation) {
        this.selectedCostMappingId = null
      } else {
        this.selectedCostMappingId = id
      }
    },
    getCostMappingList(searchTerm = '') {
      this.showLoading()
      this.getCostMapping({
        partnerId: this.partnerId,
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'DESC'
        }
      }).then(res => {
        this.totalRecords = res.data.meta.total_item
        this.hideLoading()
      })
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/package/cost-mapping', query: { page: page } })
    },
    doSearch() {
      this.getPackage(this.searchTerm)
    },
    showMore(page) {
      this.$router.push({ path: '/package/cost-mapping', query: { page: page } })
      this.page = page
      this.currentPage = page
    },
    goToDetail(target) {
      this.$router.push(`/package/cost-mapping/detail/${target}`)
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: '/package/cost-mapping', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getCostMappingList()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getCostMappingList()
      } else {
        this.$router.push({ path: '/package/cost-mapping', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  }
}
</script>
